import { ICondition } from "../../core/src/states/State";
import VendorModel from "../../server/model/VendorModel";
import BetModel from "../../core/src/model/BetModel";

export default class InsufficientBalanceCondition implements ICondition {
    check():boolean {
        return BetModel.insufficientBalance;
    }

}
